import debounce from 'lodash.debounce';
import { useCallback, useRef } from 'react';

export const useDebounce = <F extends (...args: any[]) => any>(fn: F, wait: number) => {
  const fnRef = useRef<F>(fn);
  // this mutable ref ensures that the latest instance of the passed fn is called
  fnRef.current = fn;

  const stable = useCallback((...args: Parameters<F>) => {
    fnRef.current?.(...args);
  }, []);

  return useRef(debounce(stable, wait)).current;
};
